import React, { useEffect } from 'react';
import { ModalHeader, ModalBody, Typography, Button, ModalFooter, Link, } from '@one-thd/sui-atomic-components';
import { setOverlayEvent } from '../../../../utils/analytics';
export var NoValidUsersModal = function (_a) {
    var downloadHref = _a.downloadHref, handleCancelImportNoValidUsers = _a.handleCancelImportNoValidUsers, hideModal = _a.hideModal;
    useEffect(function () {
        setOverlayEvent("invalid users can't be imported");
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement(ModalHeader, { onClose: hideModal }, "Invalid Users Can't Be Imported"),
        React.createElement(ModalBody, null,
            React.createElement(Typography, { variant: "body-base", weight: "bold" }, "We couldn't validate any users. Go back and correct the user details, or cancel the import and no users will be added at this time."),
            "\u00A0",
            React.createElement(Typography, { variant: "body-base" },
                "If you want to correct errors on the invalid user entries later,",
                ' ',
                React.createElement(Link, { href: downloadHref, download: "users.csv" }, "download this CSV file"),
                ", correct the errors, and resubmit.")),
        React.createElement(ModalFooter, null,
            React.createElement("div", { className: "sui-flex sui-justify-end sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row" },
                React.createElement(Button, { variant: "secondary", onClick: handleCancelImportNoValidUsers }, "Cancel Import"),
                React.createElement(Button, { variant: "primary", onClick: hideModal }, "Go Back")))));
};
